import { PageHeaderType, type LayoutSpec } from '../../../../types/LayoutConfig';
import { MANUAL_RFQS_LAYOUT_ID, MANUAL_RFQS_LAYOUT_TEMPLATE_ID } from '../tokens';
import { MANUAL_RFQS_LAYOUT } from './ManualRFQs';

export const MANUAL_RFQS_LAYOUT_SPEC: LayoutSpec = {
  templateId: MANUAL_RFQS_LAYOUT_TEMPLATE_ID,
  label: 'Manual RFQs',
  id: MANUAL_RFQS_LAYOUT_ID,
  pageHeader: PageHeaderType.TradingDefault,
  dockViewLayout: MANUAL_RFQS_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
